import { render } from "./DateControlRenderer.vue?vue&type=template&id=28f723db&ts=true"
import script from "./DateControlRenderer.vue?vue&type=script&lang=ts"
export * from "./DateControlRenderer.vue?vue&type=script&lang=ts"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__